import BForm from "@/components/singles/BForm/component.vue";

export default {
  name: "login",
  components: {
    BForm
  },
  props: ["hideSignup"],
  data() {
    return {
      isLoading: false,
      form: {
        valid: false,
        inputs: [
          {
            focus: true,
            icon: "fa-user",
            name: "username",
            placeholder: "Email",
            type: "text",
            validation: "required|email",
            value: ""
          },
          {
            icon: "fa-key",
            name: "password",
            placeholder: "Password",
            type: "password",
            validation: "required",
            value: ""
          }
        ]
      }
    };
  },
  computed: {},
  mounted() {
    if (this.$store.state.auth.success) {
      this.ReRoute();
    }
  },
  methods: {
    async Login() {
      this.isLoading = true;

      try {
        let data = await this.$helpers.PostApi(
          "login",
          {
            username: this.form.inputs[0].value.toLowerCase(),
            password: this.form.inputs[1].value
          },
          true
        );

        this.LoginSuccessful(data);
      } catch (err) {
        this.LoginError(err);
      }
    },

    LoginSuccessful(data) {
      this.$ls.set("user", data.user);
      this.$ls.set("role", data.role);

      this.$helpers.GetAuthInfo();

      this.isLoading = false;

      this.$helpers.ShowStatus(
        "Välkommen! <span style='margin-left:10px;' class='icon'><i class='fas fa-lg fa-grin-beam'></i></span>",
        4000
      );

      this.$helpers.ClearForm(this.form);
      this.ReRoute(true);
    },

    LoginError(err) {
      this.isLoading = false;

      this.form.inputs[1].value = "";
      this.form.inputs[1].valid = false;

      this.$helpers.ShowNotification(
        "Wrong username or password",
        "primary",
        3000
      );
    },

    ReRoute(skipMessage) {
      if (this.$store.state.auth.success) {
        if (this.$store.state.auth.role.level === 1) {
          this.$router.push({
            path: "/user"
          });
        } else {
          !skipMessage
            ? this.$helpers.ShowStatus("Du är redan inloggad.", 5000)
            : false;
          this.$router.push({
            path: "/"
          });
        }
      }
    }
  }
};
